import { render } from "./GptQuestionPanel.vue?vue&type=template&id=d0261d16&scoped=true&ts=true"
import script from "./GptQuestionPanel.vue?vue&type=script&lang=ts"
export * from "./GptQuestionPanel.vue?vue&type=script&lang=ts"

import "./GptQuestionPanel.vue?vue&type=style&index=0&id=d0261d16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0261d16"]])

export default __exports__